import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stringify } from "query-string";
import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { UserType } from "sprout-graphql";
import { Button } from "sprout-ui-dom";
import Divider from "sprout-ui-dom/dist/Divider";
import { Add } from "sprout-ui-icons";
import { Flex, Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const TopicGroupHeaderDivider = styled(Divider)`
  flex: 1;
`;
const TopicGroupHeaderTitle = styled(Text)`
  ${({ $isActive  })=>$isActive && css`
      text-decoration: underline;
    `}

  ${media.up("medium", "pointer")} {
    :hover {
      text-decoration: underline;
    }
  }
`;
const TopicGroupHeader = /*#__PURE__*/ forwardRef(function TopicGroupForwardRef(props, ref) {
    const { title , isOwnerOrAdmin , username , type , navigationItemHelpers  } = props;
    return /*#__PURE__*/ _jsxs(Flex, {
        height: "48px",
        alignItems: "center",
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(TopicGroupHeaderTitle, {
                to: `/${username}`,
                as: Link,
                fontSize: "15px",
                fontWeight: "bold",
                caps: true,
                $isActive: !!(navigationItemHelpers === null || navigationItemHelpers === void 0 ? void 0 : navigationItemHelpers.isActive),
                children: title
            }),
            /*#__PURE__*/ _jsx(TopicGroupHeaderDivider, {
                height: "1px",
                bg: "blue.500",
                ml: 1
            }),
            isOwnerOrAdmin && /*#__PURE__*/ _jsxs(Button, {
                variant: "outline",
                as: Link,
                to: {
                    pathname: "/new-tree",
                    search: stringify({
                        workspace: type === UserType.Team ? username : undefined
                    })
                },
                children: [
                    /*#__PURE__*/ _jsx(Add, {}),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        ml: 0,
                        children: "New"
                    })
                ]
            })
        ]
    });
});
export default TopicGroupHeader;
